import { useQuery } from "@tanstack/react-query";
import { GetIndustrySpecialistsResponse } from "../models/response/get-industry-specialists-response";
import { getIndustrySpecialists } from "../services/industry-specialist-service";
import { ApiError } from "pages/admin-app/shared/models/response/api-errors";
import { ORDER_BY, PER_PAGE } from "pages/admin-app/adminapp.constants";

interface Props {
  currentPage: number;
  sortBy?: string;
  orderBy?: ORDER_BY;
  filters?: { [key: string]: string };
  searchQuery?: string;
}

export function useIndustrySpecialists({
  currentPage,
  sortBy,
  orderBy,
  filters,
  searchQuery,
}: Props) {
  const { data, error, isLoading, isError, refetch, isFetching } = useQuery<
    GetIndustrySpecialistsResponse,
    ApiError
  >({
    queryKey: [
      "industrySpecialists",
      currentPage,
      sortBy,
      orderBy,
      filters,
      searchQuery,
    ],
    queryFn: () =>
      getIndustrySpecialists({
        page: currentPage,
        perPage: PER_PAGE,
        sortBy,
        orderBy,
        filters,
        searchQuery,
      }),
  });

  const baseErrorResponse = error ? error.message : null;

  return {
    data: data,
    error: baseErrorResponse,
    isLoading,
    isError,
    refetch,
    isFetching,
  };
}
